import _ from "lodash";

export function getNodeIdFromPkidOrId(pkidOrId: string) {
  if (pkidOrId?.includes("-")) {
    const [nid, did] = pkidOrId.split("-");
    return nid;
  } else {
    return pkidOrId;
  }
}

export function getNodeAndDestinationIdFromPkid(id: string | undefined) {
  if (!id) {
    return [undefined, undefined];
  }

  return (_.isNumber(id) ? [`${id}`, undefined] : id?.split("-")) as [
    string,
    string
  ];
}
